export default {
    state: {
     institution : {},
    },
  
    getters: {
      getInstitutionData(state) {
        return state.institution;
      },
    },
  
    mutations: {
     setInstitutionData(state, data) {
        const isNull = data === null;
  
        state.institution = {
          id: !isNull ? data.id : "",
          address: !isNull ? data.address : "",
          cep: !isNull ? data.cep : "",
          city: !isNull ? data.city : "",
          cnes: !isNull ? data.cnes : "",
          cnpj: !isNull ? data.cnpj : "",
          complement: !isNull ? data.complement : "",
          enabled: !isNull ? data.enabled : "",
          name: !isNull ? data.name : "",
          regional: !isNull ? data.regional : "",
          users: !isNull ? data.users : "",
          
        };
      },
    },
  
    actions: {
     changeInstitutionData(context, infos) {
        context.commit("setInstitutionData", infos);
      },
    },
  };
  